(function () {
'use strict';

document.addEventListener('click', function (event) {

var button = event.target.closest('[data-product-atc]');

if (!button) {
  return;
}

var form = button.closest('[data-product-form]');

if (!form) {
  return;
}

var addonSelect = form.querySelector('[data-veto-promo-select]');

/*
 * If this isn't a Veto Promo product, do nothing.
 */
if (!addonSelect) {
  return;
}

/*
 * If "No thanks" is selected, let Empire handle
 * the normal Add to Cart process.
 */
if (!addonSelect.value) {
  return;
}

/*
 * Stop Empire's normal submission.
 */
event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();

var variantInput = form.querySelector('input[name="id"]');

if (!variantInput || !variantInput.value) {
  console.error('Veto Promo: Product variant not found.');
  return;
}

var mainVariantId = parseInt(variantInput.value, 10);
var addonVariantId = parseInt(addonSelect.value, 10);

/*
 * Get product quantity.
 */
var quantityInput = form.querySelector('[data-quantity-input]');
var quantity = 1;

if (quantityInput && quantityInput.value) {
  quantity = parseInt(quantityInput.value, 10) || 1;
}

/*
 * Empire's quantity dropdown.
 * Use it when the numeric quantity field hasn't
 * been manually changed.
 */
var quantitySelect = form.querySelector('[data-quantity-select]');

if (
  quantity === 1 &&
  quantitySelect &&
  quantitySelect.value &&
  quantitySelect.value !== '10+'
) {
  quantity = parseInt(quantitySelect.value, 10) || 1;
}

/*
 * Prevent double-clicks.
 */
if (button.dataset.vetoAdding === 'true') {
  return;
}

button.dataset.vetoAdding = 'true';

/*
 * Preserve the original button text.
 */
var buttonText = button.querySelector('.atc-button--text');
var originalText = buttonText
  ? buttonText.textContent
  : '';

button.disabled = true;
button.classList.add('disabled');

if (buttonText) {
  buttonText.textContent = 'Adding...';
}

/*
 * Add both products in ONE Shopify cart request.
 */
fetch(
  window.Shopify.routes.root + 'cart/add.js',
  {
    method: 'POST',

    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },

    body: JSON.stringify({
      items: [
        {
          id: mainVariantId,
          quantity: quantity
        },
        {
          id: addonVariantId,
          quantity: 1
        }
      ]
    })
  }
)

.then(function (response) {

  if (!response.ok) {
    return response.json().then(function (error) {
      throw error;
    });
  }

  return response.json();

})

.then(function (result) {

  console.log(
    'Veto Promo: Main product and add-on added.',
    result
  );

  /*
   * Get the updated cart.
   */
  return fetch(
    window.Shopify.routes.root + 'cart.js',
    {
      headers: {
        'Accept': 'application/json'
      }
    }
  );

})

.then(function (response) {
  return response.json();
})

.then(function (cart) {

  console.log(
    'Veto Promo: Updated cart.',
    cart
  );

  /*
   * Try to notify Empire that the cart changed.
   */
  document.dispatchEvent(
    new CustomEvent('cart:updated', {
      detail: {
        cart: cart
      }
    })
  );

  document.dispatchEvent(
    new CustomEvent('veto:cart:updated', {
      detail: {
        cart: cart,
        addonVariantId: addonVariantId
      }
    })
  );

  /*
   * Open the cart drawer if Empire exposes
   * a cart toggle.
   */
  var cartToggle =
    document.querySelector('[data-cart-toggle]') ||
    document.querySelector('[data-cart-drawer-toggle]');

  if (cartToggle) {

    cartToggle.click();

  } else {

    /*
     * Reliable fallback.
     */
    window.location.href =
      window.Shopify.routes.root + 'cart';

    return;

  }

  /*
   * Restore button.
   */
  button.disabled = false;
  button.classList.remove('disabled');
  button.removeAttribute('data-veto-adding');

  if (buttonText) {
    buttonText.textContent = originalText;
  }

})

.catch(function (error) {

  console.error(
    'Veto Promo: Could not add products.',
    error
  );

  button.disabled = false;
  button.classList.remove('disabled');
  button.removeAttribute('data-veto-adding');

  if (buttonText) {
    buttonText.textContent = originalText;
  }

  alert(
    'There was a problem adding the accessory. Please try again.'
  );

});


}, true);

})();